import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useSoldGoodsUncategorisedList } from '@shared/api/lib/sold-goods/sold-goods';
import {
  PaginatedUncategorisedSoldGoodList,
  SoldGoodsUncategorisedListParams,
} from '@shared/api/types';

/** Uncategorised sold goods — items the goods-import classifier left as
 *  'uncertain' or 'other'. Reviewed in the Excluded items hub.
 *
 *  Bulk "change type" actions on these items now go through the unified
 *  `useBulkUpdateSoldGoods` hook in `./bulk` (action `change-type` with a
 *  `targetType`). */
export const useGetSoldUncategorisedList = (
  params?: SoldGoodsUncategorisedListParams,
  { enabled }: { enabled?: boolean } = {}
) =>
  useSoldGoodsUncategorisedList<PaginatedUncategorisedSoldGoodList>(params, {
    request: useAxiosConfig(),
    query: { keepPreviousData: true, enabled },
  });
